/* eslint-disable @typescript-eslint/no-explicit-any */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { TextHeading } from '../../../Typography';
import { Header } from '../styles';
import { useFocus } from '../../../tools/utils';
const CardHeader = (_a) => {
    var { row, headingLevel, isLoading, isFocused } = _a, other = __rest(_a, ["row", "headingLevel", "isLoading", "isFocused"]);
    const [focusRef, setFocus] = useFocus();
    useEffect(() => {
        if (isFocused)
            setFocus();
    }, [isFocused, setFocus]);
    return (React.createElement(Header, null,
        React.createElement(TextHeading, Object.assign({ ref: focusRef, tag: headingLevel, size: "xs", weight: "bold", tabIndex: -1 }, other), !isLoading && row.cells[0].render('Cell'))));
};
export { CardHeader };
//# sourceMappingURL=CardHeader.js.map